<template>
<div>
    <Breadcrumbs main="Admin" submain="Portfolio" title="Collaborations" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                            <i class="fa fa-light fa-plus"></i>
                            <h7>Add New Collaboration</h7>
                        </button>
                    </div>

                    <div class="card-body">
                        <b-row>
                            <b-col xl="6">
                                <b-input-group class="datatable-btn">
                                    <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                                    <b-input-group-append>
                                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue">
                                <b-table show-empty stacked="md" :items="collaboration_list" :fields="tablefields" :filter="filter" :current-page="currentPage" :per-page="perPage" @filtered="onFiltered">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(serial)="row">
                                        <div v-if="row.item.serial">
                                            <p>{{ row.item.serial }}</p>
                                        </div>
                                    </template>

                                    <template #cell(position)="row">
                                        <div v-if="row.item.position" style="min-width: 250px;">
                                            <p>{{ row.item.position }}</p>
                                        </div>
                                    </template>

                                    <template #cell(logo)="row">
                                        <img :src="host+row.item.logo" alt="" style="width: 120px; height: 80px;">
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title">
                                            <p>{{ row.item.title }}</p>
                                        </div>
                                    </template>

                                    <!-- <template #cell(link)="row">
                                        <div v-if="row.item.link">
                                            <a :href="row.item.link" target="_blank" class="link-style">{{ row.item.link.substring(0,40) }}</a>
                                        </div>
                                        <div v-else>
                                            N/A
                                        </div>
                                    </template> -->

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deleteCollaboration(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editCollaboration(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- BLog Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Collaboration" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter collaboration title" v-model="collaboration.title">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Position</label>
                        <input class="form-control" type="text" placeholder="Enter collaboration position" v-model="collaboration.position">
                    </div>
                </div>
            </div>
           
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter link URL" v-model="collaboration.link">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Serial</label>
                        <input class="form-control" type="number" placeholder="Enter serial" v-model="collaboration.serial" min="1">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Logo</label>
                        <div class="flex items-center">
                            <img v-if="show_logo" style="width: 120px; height: 80px;" :src="show_logo">
                            <input :class="collaboration.logo ? 'ml-4' : 'ml-0'" type="file" accept="logo/*" @change="uploadFile">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Collaboration Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Collaboration" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter title" v-model="edit_collaboration.title">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Position</label>
                        <input class="form-control" type="text" placeholder="Enter collaboration position" v-model="edit_collaboration.position">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Link</label>
                        <input class="form-control" type="text" placeholder="Enter link URL" v-model="edit_collaboration.link">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Serial</label>
                        <input class="form-control" type="number" placeholder="Enter serial" v-model="edit_collaboration.serial" min="1">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Logo</label>
                        <div class="flex items-center">
                            <img v-if="show_logo" style="width: 120px; height: 80px;" :src="show_logo">
                            <input :class="edit_collaboration.logo ? 'ml-4' : 'ml-4'" type="file" accept="logo/*" @change="EdituploadFile">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Collaboration Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this collaboration?</div>
    </b-modal>
</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import moment from "moment";
import { mapState } from 'vuex';
import { myHost } from '../../../_helpers/host';
import js from '../../../auth/js';
import loader from '../loader/loader.vue';

export default {
    components: {
        Datepicker,
        loader
    },

    data() {
        return {
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [
                {
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'serial',
                    label: 'Serial',
                    sortable: true
                },
                {
                    key: 'logo',
                    label: 'Logo',
                    sortable: true
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'position',
                    label: 'Position',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],
            
            collaboration: {
                title: '',
                position:'',
                logo: '',
                link: '',
                serial: null
            },

            edit_collaboration: {
                id: '',
                title: '',
                position:'',
                logo: '',
                link: '',
                serial: null
            },

            show_logo: null,
            delete_value: null,

            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15]
        };
    },

    computed: {
        ...mapState({
            collaboration_list: state => state.collaboration.collaboration,
            loading: state => state.collaboration.collaborationLoading,
            error: state => state.collaboration.collaborationError
        }),

        sortOptions() {
            // Create an options list from our fields
            return this.tablefields
            .filter(f => f.sortable)
            .map(f => {
                return {
                    text: f.label,
                    value: f.key
                };
            });
        }
    },

    mounted() {
        this.$store.dispatch("collaboration/fetchCollaboration").then(() => {
            this.items = this.collaboration_list
            this.totalRows = this.items.length;
        })
    },

    methods: {
        uploadFile(e) {
            const logo = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(logo);
            reader.onload = e => {
                this.show_logo = e.target.result
                this.collaboration.logo = e.target.result;
            };
        },

        EdituploadFile(e) {
            const logo = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(logo);
            reader.onload = e => {
                this.show_logo = e.target.result
                this.edit_collaboration.logo = e.target.result;
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.collaboration.title = null
            this.collaboration.logo = null
            this.collaboration.position = null
            this.collaboration.serial = null
            this.collaboration.link = null
            this.show_logo = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("collaboration/addCollaboration", {
                collaboration: this.collaboration
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.collaboration.title = null
                    this.collaboration.logo = null
                    this.collaboration.position = null
                    this.collaboration.serial = null
                    this.collaboration.link = null
                    this.show_logo = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editCollaboration(detail) {
            this.edit_collaboration.id = detail.id ? detail.id : null
            this.edit_collaboration.title = detail.title ? detail.title : null
            this.edit_collaboration.position = detail.position ? detail.position : null
            this.edit_collaboration.link = detail.link ? detail.link : null
            this.show_logo = detail.logo ? this.host + detail.logo : null
            this.edit_collaboration.serial = detail.serial ? detail.serial : null
        },

        resetEditModal() {
            this.edit_collaboration.title = null
            this.edit_collaboration.logo = null
            this.edit_collaboration.position = null
            this.edit_collaboration.serial = null
            this.edit_collaboration.link = null
            this.show_logo = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("collaboration/updateCollaboration", {
                id: this.edit_collaboration.id,
                collaboration: this.edit_collaboration,
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.edit_collaboration.title = null
                    this.edit_collaboration.logo = null
                    this.edit_collaboration.position = null
                    this.edit_collaboration.serial = null
                    this.edit_collaboration.link = null
                    this.show_logo = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        deleteCollaboration(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("collaboration/deleteCollaboration", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null

                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
